// extracted by mini-css-extract-plugin
export default {"tagsWrapper":"InstructionsSidebar_tagsWrapper__3xEWV","tag":"InstructionsSidebar_tag__jVSAA","remove":"InstructionsSidebar_remove__MMwjE"};